import type { EChartsOption } from 'echarts';

import type { SeriesPoint } from './model';

const compact = new Intl.NumberFormat('en-AU', { notation: 'compact', maximumFractionDigits: 1 });

const axisLabel = { formatter: (value: number) => compact.format(value) };

export function trendOption(points: ReadonlyArray<SeriesPoint>, kind: 'line' | 'bar' = 'line'): EChartsOption {
  const dates = [...new Set(points.map((point) => point.date))].sort();
  const names = [...new Set(points.map((point) => point.series))];
  const lookup = new Map(points.map((point) => [`${point.date}|${point.series}`, point.value]));
  return {
    tooltip: { trigger: 'axis' },
    legend: { type: 'scroll', top: 0 },
    grid: { left: 56, right: 16, top: 36, bottom: 56 },
    xAxis: { type: 'category', data: dates },
    yAxis: { type: 'value', axisLabel },
    dataZoom: dates.length > 60 ? [{ type: 'slider', bottom: 8 }] : undefined,
    series: names.map((name) => ({
      name,
      type: kind,
      stack: kind === 'bar' ? 'total' : undefined,
      showSymbol: false,
      data: dates.map((date) => lookup.get(`${date}|${name}`) ?? 0),
    })),
  };
}

export function barOption(
  categories: ReadonlyArray<string>,
  series: ReadonlyArray<{ name: string; data: ReadonlyArray<number | null> }>,
  stacked = false,
): EChartsOption {
  return {
    tooltip: { trigger: 'axis' },
    legend: series.length > 1 ? { type: 'scroll', top: 0 } : undefined,
    grid: { left: 56, right: 16, top: series.length > 1 ? 36 : 16, bottom: 40 },
    xAxis: { type: 'category', data: [...categories], axisLabel: { interval: 0, hideOverlap: true } },
    yAxis: { type: 'value', axisLabel },
    series: series.map((item) => ({
      name: item.name,
      type: 'bar',
      stack: stacked ? 'total' : undefined,
      data: [...item.data],
    })),
  };
}
